import { type FC, type ReactNode } from "react";

export type AtomValueProps = {
	children?: ReactNode;
};

export const AtomValue: FC<AtomValueProps> = ({ children }) => {
	return <span className="text-syntax-atom">{children}</span>;
};
